import React from "react";
import { ReactDOM } from "react";




function Projects(props){
    return(
        
    <div id="project" className="cards card-area">
                <img class=" project-img" src={props.image}></img>
                 <div class="card-body ">
                  <h3 class="card-text">{props.text}</h3>
                  
                 </div>
                 <button className="project-btn"><a href={props.address} >View Project</a></button>
            </div>
             
    
    );
}



export default Projects;